import { useLocalObservable } from "mobx-react-lite";
import { createContext, ReactNode, useContext } from "react";

import { GridSelectionStore } from "./grid-selection-store";

export const createGridSelectionContext = <TId extends string | number>(contextName: string) => {
  const Context = createContext<GridSelectionStore<TId> | null>(null);

  const Provider = ({ children }: { children: ReactNode }) => {
    const store = useLocalObservable(() => new GridSelectionStore<TId>());
    return <Context.Provider value={store}>{children}</Context.Provider>;
  };

  const useStore = (): GridSelectionStore<TId> => {
    const store = useContext(Context);
    if (!store) {
      throw new Error(`${contextName} must be used within its Provider`);
    }
    return store;
  };

  return { Provider, useStore, Context };
};
